import * as actionTypes from "../actions";
import {getVirtualShifts} from "../../helpers";


const initialState = {
    form: actionTypes.getInitOrderForm(),

    current_order: {},

    paymentIntentClientSecret: null,
    createPaymentIntentLoading: false,
    createPaymentIntentError: null,

    createPaymentSourceLoading: false,
    createPaymentSourceError: null,

    createUponPickupPaymentLoading: false,
    createUponPickupPaymentError: null,

    orderSettings : {
        "shop_enabled": false,
        "stripe_account_id": false,
        "shifts": [],
        "products": [],
        "restaurant_settings": {
            "name": "",
            "address": "",
            "phone": "",
            "email": "",
            "latitude": 50.7436511942499,
            "longitude": 3.21471333503723,
            "zoom": 17,
            "logo": "",
            "banner": ""
        },
        "minimum_order_amount": "5.00",
        "min_duration": "1 00:00:00",
        "max_duration": "14 00:00:00",
        "delivery_enabled": false,
        "delivery_max_distance": 15,
        "delivery_price": "5.00",
        "delivery_free_enabled": false,
        "delivery_free_above": "20.00"
    },
    getOrderSettingsLoading: true,
    getOrderSettingsError: null,

    cart: [],

    virtualShifts: [],

    orderSelectedShift: null,
    orderSelectedDate: null,

    deliveryIsBlocked: false,

    confirmOrderLoading: false,
    confirmOrderError: null,

    checkDistanceLoading: false,
    checkDistanceError: null,

    currentOrderSummary: {},
    getCurrentOrderLoading: true,
    getCurrentOrderError: null,
    doesOrderExist: null,
    cancelOrderLoading: false,
    cancelOrderError: false,
};

const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        // RESET ORDER
        case actionTypes.RESET_ORDER:
            return {
                ...state,
                form: actionTypes.getInitOrderForm(),
                current_order: {},
                cart: [],
                paymentIntentClientSecret: null,
                createPaymentIntentLoading: false,
                createPaymentIntentError: null,
                createPaymentSourceLoading: false,
                createPaymentSourceError: null,
                orderSelectedShift: null,
                orderSelectedDate: null,
                deliveryIsBlocked: false,
                confirmOrderLoading: false,
                confirmOrderError: null,
                checkDistanceLoading: false,
                checkDistanceError: null,
            };

        // CHANGE SHOP FORM
        case actionTypes.CHANGE_ORDER_FORM:
            return {
                ...state,
                form: action.form
            };

        // UPDATE CART
        case actionTypes.UPDATE_CART:
            return {
                ...state,
                cart: action.cart
            };

        // UPDATE ORDER SELECTED SHIFT
        case actionTypes.UPDATE_ORDER_SELECTED_SHIFT:
            return {
                ...state,
                orderSelectedShift: action.orderSelectedShift
            };

        // UPDATE ORDER SELECTED DATE
        case actionTypes.UPDATE_ORDER_SELECTED_DATE:
            return {
                ...state,
                orderSelectedDate: action.orderSelectedDate
            };

        // CONFIRM ORDER
        case actionTypes.CONFIRM_ORDER_REQUEST:
            return {
                ...state,
                confirmOrderLoading: action.loading
            };
        case actionTypes.CONFIRM_ORDER_SUCCESS:
            return {
                ...state,
                confirmOrderLoading: action.loading,
                confirmOrderError: action.error,
                current_order: action.current_order
            };
        case actionTypes.CONFIRM_ORDER_ERROR:
            return {
                ...state,
                confirmOrderLoading: action.loading,
                confirmOrderError: action.error
            };

        // GET ORDER SETTINGS
        case actionTypes.GET_ORDER_SETTINGS_REQUEST:
            return {
                ...state,
                getOrderSettingsLoading: action.loading
            };
        case actionTypes.GET_ORDER_SETTINGS_SUCCESS:
            return {
                ...state,
                getOrderSettingsLoading: action.loading,
                getOrderSettingsError: action.error,
                orderSettings: action.orderSettings,
                virtualShifts: getVirtualShifts(action.orderSettings.shifts),
            };
        case actionTypes.GET_ORDER_SETTINGS_ERROR:
            return {
                ...state,
                getOrderSettingsLoading: action.loading,
                getOrderSettingsError: action.error
            };

        // CREATE PAYMENT INTENT
        case actionTypes.CREATE_PAYMENT_INTENT_REQUEST:
            return {
                ...state,
                createPaymentIntentLoading: action.loading
            };
        case actionTypes.CREATE_PAYMENT_INTENT_SUCCESS:
            return {
                ...state,
                createPaymentIntentLoading: action.loading,
                createPaymentIntentError: action.error,
                paymentIntentClientSecret: action.paymentIntentClientSecret
            };
        case actionTypes.CREATE_PAYMENT_INTENT_ERROR:
            return {
                ...state,
                createPaymentIntentLoading: action.loading,
                createPaymentIntentError: action.error
            };

        // CREATE PAYMENT SOURCE
        case actionTypes.CREATE_PAYMENT_SOURCE_REQUEST:
            return {
                ...state,
                createPaymentSourceLoading: action.loading
            };
        case actionTypes.CREATE_PAYMENT_SOURCE_SUCCESS:
            return {
                ...state,
                createPaymentSourceLoading: action.loading,
                createPaymentSourceError: action.error,
            };
        case actionTypes.CREATE_PAYMENT_SOURCE_ERROR:
            return {
                ...state,
                createPaymentSourceLoading: action.loading,
                createPaymentSourceError: action.error
            };

        // CREATE UPON PICKUP PAYMENT
        case actionTypes.CREATE_UPON_PICKUP_PAYMENT_REQUEST:
            return {
                ...state,
                createUponPickupPaymentLoading: action.loading
            };
        case actionTypes.CREATE_UPON_PICKUP_PAYMENT_SUCCESS:
            return {
                ...state,
                createUponPickupPaymentLoading: action.loading,
                createUponPickupPaymentError: action.error,
            };
        case actionTypes.CREATE_UPON_PICKUP_PAYMENT_ERROR:
            return {
                ...state,
                createUponPickupPaymentLoading: action.loading,
                createUponPickupPaymentError: action.error
            };

        case actionTypes.BLOCK_DELIVERY:
            return {
                ...state,
                deliveryIsBlocked: true
            };

        // CHECK DISTANCE
        case actionTypes.CHECK_DISTANCE_REQUEST:
            return {
                ...state,
                checkDistanceLoading: action.loading
            };
        case actionTypes.CHECK_DISTANCE_SUCCESS:
            return {
                ...state,
                checkDistanceLoading: action.loading,
                checkDistanceError: action.error,
            };
        case actionTypes.CHECK_DISTANCE_ERROR:
            return {
                ...state,
                checkDistanceLoading: action.loading,
                checkDistanceError: action.error
            };

        // GET CURRENT ORDER
        case actionTypes.GET_CURRENT_ORDER_REQUEST:
            return {
                ...state,
                getCurrentOrderLoading: action.loading
            };
        case actionTypes.GET_CURRENT_ORDER_SUCCESS:
            return {
                ...state,
                getCurrentOrderLoading: action.loading,
                getCurrentOrderError: action.error,
                currentOrderSummary: action.order,
                doesOrderExist: true
            };
        case actionTypes.GET_CURRENT_ORDER_ERROR:
            return {
                ...state,
                getCurrentOrderLoading: action.loading,
                getCurrentOrderError: action.error,
                doesOrderExist: false
            };

        // CANCEL ORDER
        case actionTypes.CANCEL_ORDER_REQUEST:
            return {
                ...state,
                cancelOrderLoading: action.loading
            };
        case actionTypes.CANCEL_ORDER_SUCCESS:
            return {
                ...state,
                cancelOrderLoading: action.loading,
                cancelOrderError: action.error,
            };
        case actionTypes.CANCEL_ORDER_ERROR:
            return {
                ...state,
                cancelOrderLoading: action.loading,
                cancelOrderError: action.error
            };

        default:
            return state;
    }
};

export default orderReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/order.js